import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Icon from "@/components/Icon";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

export default function Blog() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");
  const [page, setPage] = useState(1);

  const load = useCallback(() => {
    api.get("/blog/posts", { params: { q: q || undefined, category: cat, page, page_size: 9 } }).then(({ data }) => setData(data)).catch(() => setData({ items: [], categories: [], total: 0, page_size: 9 }));
  }, [q, cat, page]);
  useEffect(() => { load(); }, [load]);

  const pages = data ? Math.max(1, Math.ceil(data.total / data.page_size)) : 1;

  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />
      <div className="max-w-5xl mx-auto px-4 py-12">
        <h1 className="text-4xl sm:text-5xl font-display font-extrabold">Blog</h1>
        <p className="text-muted-foreground mt-2">Guides, tips and product updates.</p>

        <div className="flex flex-wrap gap-2 mt-6">
          <div className="relative flex-1 min-w-[200px] max-w-sm"><Icon name="Search" className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" /><input data-testid="blog-search" value={q} onChange={(e) => { setPage(1); setQ(e.target.value); }} placeholder="Search articles" className="w-full rounded-xl border border-input bg-background pl-9 pr-3 py-2 text-sm" /></div>
          <button onClick={() => { setPage(1); setCat("all"); }} className={`rounded-xl px-3 py-2 text-sm font-semibold border ${cat === "all" ? "border-primary bg-primary text-primary-foreground" : "border-border"}`}>All</button>
          {(data?.categories || []).map((c) => <button key={c.id} data-testid={`blog-cat-${c.slug}`} onClick={() => { setPage(1); setCat(c.name); }} className={`rounded-xl px-3 py-2 text-sm font-semibold border ${cat === c.name ? "border-primary bg-primary text-primary-foreground" : "border-border"}`}>{c.name}</button>)}
        </div>

        {!data ? <div className="grid place-items-center py-24"><Icon name="Loader2" className="h-7 w-7 animate-spin text-primary" /></div> : data.items.length === 0 ? (
          <div className="py-24 text-center text-muted-foreground" data-testid="blog-empty">No articles yet. Check back soon.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8" data-testid="blog-grid">
            {data.items.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group rounded-2xl border border-border bg-card overflow-hidden hover:border-primary/40 transition-colors">
                {p.featured_image ? <img src={p.featured_image} alt="" className="w-full h-40 object-cover" /> : <div className="w-full h-40 bg-primary/10 grid place-items-center"><Icon name="Newspaper" className="h-8 w-8 text-primary/50" /></div>}
                <div className="p-4">
                  {p.category && <span className="text-xs font-semibold text-primary">{p.category}</span>}
                  <h3 className="font-display font-bold mt-1 group-hover:text-primary transition-colors">{p.title}</h3>
                  <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{p.excerpt}</p>
                  <div className="text-xs text-muted-foreground mt-3">{p.author} · {p.publish_date ? new Date(p.publish_date).toLocaleDateString() : ""}</div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {pages > 1 && (
          <div className="flex items-center justify-center gap-2 mt-10">
            <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)} className="rounded-lg border border-border px-3 py-1.5 text-sm disabled:opacity-40">Prev</button>
            <span className="text-sm text-muted-foreground">Page {page} of {pages}</span>
            <button disabled={page >= pages} onClick={() => setPage((p) => p + 1)} className="rounded-lg border border-border px-3 py-1.5 text-sm disabled:opacity-40">Next</button>
          </div>
        )}
      </div>
      <PublicFooter />
    </div>
  );
}